const findFileFieldName = require("./findFileFieldName");
module.exports = function extractVideoData(entity) {
	function findVideo(rels) {
		let video_rel;
		for (const [, { data }] of Object.entries(rels)) {
			let _data = Array.isArray(data) ? data[0] : data;
			if (_data && _data.type === "media--video") {
				video_rel = _data;
				break;
			}
		}
		return video_rel;
	}

	if (entity) {
		let video_rel =
			entity && entity.relationships ? findVideo(entity.relationships) : null;
		if (video_rel) {
			let file_field_name = findFileFieldName(video_rel);

			const file_data = video_rel.relationships[file_field_name]
				? video_rel.relationships[file_field_name].data
				: null;

			if (file_data && file_data.attributes && file_data.attributes.uri) {
				let video = {
					...file_data.attributes,
					url: `${process.env.CLF_BACKEND_URL}${file_data.attributes.uri.url}`,
				};
				return video;
			}
		}
	}
	return null;
};
